<template>
  <div>
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />
    <Navbar />
    <div class="step-page application-record">
      <template v-if="showRecord">
        <perfect-scrollbar class="progress-job-list">
          <div
            v-for="record in recordList"
            :key="record.index"
            class="job-item"
            :class="{
              active: record.MatchId === selectedDemandMatchId,
            }"
            @click="showApplicationRecord(record.MatchId)"
          >
            <div class="info">
              <div class="job-name">{{ record.ManpowerDemandName }}</div>
              <div class="d-number">{{ record.ManpowerDemandNo }}</div>
            </div>
          </div>
        </perfect-scrollbar>
        <section v-if="showProgress" class="timeline">
          <ul>
            <li class="welcome">
              <div>應徵進度</div>
            </li>
            <li v-for="history in jobHistoryList" :key="history.index">
              <div>
                <div class="icon-wrap">
                  <eva-icon fill="#FFF" name="pricetags-outline"></eva-icon>
                </div>
                <!-- Process 1. 履歷審核 (投遞履歷至面談邀約期間) -->
                <template v-if="history.TypeName === 'WriteResume'">
                  <div class="time-wrap">
                    <strong>親愛的求職者</strong>
                  </div>
                  <div class="note-wrap">
                    歡迎隨時更新個人履歷資料，祝面試順利。
                  </div>
                </template>
                <!-- Process 2. 等待面試 (面談邀約至面試當天期間) -->
                <template v-if="history.TypeName === 'InterviewInvitation'">
                  <div class="time-wrap">
                    {{ history.OccurDate }}
                  </div>
                  <div class="text-wrap">等待面試</div>
                  <div class="note-wrap">
                    誠摯邀請您來參加本公司面試，請點選下方按鈕檢視邀約信件。
                  </div>
                </template>
                <!-- Process 3. 結果審核 ( IF面試結果為考慮中、複試、錄取，則面試結束至發Offer期間為此階段) -->
                <template v-if="history.TypeName === 'Interview'">
                  <div class="time-wrap">
                    {{ history.OccurDate }}
                  </div>
                  <div class="text-wrap">結果審核</div>
                  <div class="note-wrap">
                    {{ history.Status }}
                  </div>
                </template>
                <!-- Process 4. 審核結束 ( IF面試結果為不錄取，則面試結束後便直接跳至此階段、 IF面試結果為考慮中、複試、錄取，則發Offer後跳至此階段) -->
                <template v-if="history.TypeName === 'InterviewResult'">
                  <div class="time-wrap">
                    {{ history.OccurDate }}
                  </div>
                  <div class="text-wrap">審核結束</div>
                  <div class="note-wrap">
                    {{ history.Status }}
                  </div>
                </template>
                <template v-if="history.TypeName === 'ThanksNotice'">
                  <div class="time-wrap">
                    {{ history.OccurDate }}
                  </div>
                  <div class="note-wrap">
                    感謝您在百忙中撥冗前來面試，祝您萬事如意、身體健康。
                  </div>
                </template>
                <template v-if="history.TypeName === 'HireNotice'">
                  <div class="time-wrap">
                    {{ history.OccurDate }}
                  </div>
                  <div class="text-wrap">審核結束-錄取通知</div>
                  <div class="note-wrap">
                    感謝您參加本公司面試，經主管評核，很榮幸通知您的經歷符合職缺需求，<br />
                    請點選下方按鈕回覆報到意願或檢視錄取信件。
                  </div>
                </template>
                <template v-if="history.TypeName === 'OnboardIntention'">
                  <div class="time-wrap">
                    {{ history.OccurDate }}
                  </div>
                  <div class="text-wrap">審核結束-意願回覆</div>
                  <div class="note-wrap">
                    <template v-if="history.Status === '願意報到'">
                      您已回覆願意報到
                    </template>
                    <template v-else> 您已回覆無意願報到 </template>
                  </div>
                </template>
                <template v-if="history.TypeName === 'ReportNotice'">
                  <div class="time-wrap">
                    {{ history.OccurDate }}
                  </div>
                  <div class="text-wrap">審核結束-報到通知</div>
                  <div class="note-wrap">
                    歡迎您加入我們團隊，請依報到程序進行報到。
                  </div>
                </template>
                <div class="button-wrap">
                  <button
                    v-if="history.TypeName === 'WriteResume'"
                    type="button"
                    class="btn"
                    @click="showResume"
                  >
                    維護履歷
                  </button>
                  <button
                    v-if="history.TypeName === 'InterviewInvitation'"
                    type="button"
                    class="btn"
                    data-toggle="modal"
                    @click="showInterviewMail(history.InterviewId)"
                  >
                    檢視邀約信件
                  </button>
                  <template v-if="history.TypeName === 'ThanksNotice'">
                    <button
                      type="button"
                      class="btn"
                      data-toggle="modal"
                      @click="showThankYouMail"
                    >
                      檢視感謝函
                    </button>
                  </template>
                  <template v-if="history.TypeName === 'HireNotice'">
                    <button
                      type="button"
                      class="btn"
                      data-toggle="modal"
                      @click="showHiringMail"
                    >
                      檢視錄取信件
                    </button>
                    <button
                      v-if="history.TypeName === 'HireNotice'"
                      type="button"
                      class="btn"
                      style="margin-left: 10px"
                      @click="$router.push(`/decline_report/${MatchId}`)"
                    >
                      回覆報到意願
                    </button>
                  </template>

                  <template v-if="history.TypeName === 'ReportNotice'">
                    <button
                      type="button"
                      class="btn"
                      data-toggle="modal"
                      @click="showReportMail"
                    >
                      檢視報到信件
                    </button>
                  </template>
                </div>
              </div>
            </li>
          </ul>
        </section>
      </template>
      <template v-if="!showRecord">
        <section>
          <div class="notice">
            <img src="@/assets/img/no_record.png" alt="" />
            <p>您尚未應徵任何職缺</p>
          </div>
        </section>
      </template>
    </div>

    <!-- 信件 Modal -->
    <div
      id="mailModal"
      class="modal fade bd-example-modal-xl"
      tabindex="-1"
      data-backdrop="static"
    >
      <div
        class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg"
      >
        <div class="modal-content">
          <button
            type="button"
            class="close text-right"
            style="margin-right: 6px"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span style="color: #fff" aria-hidden="true">&times;</span>
          </button>
          <perfect-scrollbar class="modal-body">
            <div class="title">
              <h2>
                <i class="fa fa-briefcase icon1" aria-hidden="true"></i>
                <span class="sr-only">Offer Letter</span>
              </h2>
              <h4>{{ mailContent.Subject }}</h4>
              <div style="float: right">
                <p
                  v-if="mailContent.OfferFileGroupId"
                  class="download-file"
                  @click="
                    $common.downloadFileGroup({
                      fileGuid: mailContent.OfferFileGroupId,
                      fileTitle: 'application/pdf',
                    })
                  "
                >
                  檢視 Offer
                </p>
              </div>
            </div>
            <div class="form-content">
              <p v-html="mailContent.Body"></p>
            </div>
          </perfect-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";
import Navbar from "@/components/candidate/NavBar";

export default {
  name: "ApplicationRecord",

  components: {
    Navbar,
  },
  data() {
    return {
      year: null, // 年
      date: null, // 日期

      // 左測
      showRecord: true,
      recordList: [],
      MatchId: null,
      ResumeType: null,

      // 右側
      selectedDemandMatchId: null,
      showProgress: false,
      jobHistoryList: [],

      // 信件
      mailContent: {},
    };
  },

  methods: {
    // 取得 應徵職缺列表
    getApplicationRecord() {
      this.updateLoading(true);
      this.$api.recruitment
        .getJobByUserOfFront(this.$cookies.get("candidateId"))
        .then((response) => {
          if (response.status === 200) {
            this.recordList = response.data;
            if (response.data.length > 0) {
              this.showRecord = true;
              this.showApplicationRecord(response.data[0].MatchId);
            } else {
              this.showRecord = false;
              this.selectedDemandMatchId = null;
            }
          }
          this.updateLoading(false);
        });
    },

    // 檢視 歷程
    showApplicationRecord(matchId) {
      this.selectedDemandMatchId = matchId;
    },

    // 檢視 履歷
    showResume() {
      switch (this.ResumeType) {
        case "IDL":
          this.$router.push({ path: "/candidate/idl" });
          break;
        case "DL":
          this.$router.push({ path: "/candidate/dl" });
          break;
      }
    },

    // 檢視 面談邀約信件
    showInterviewMail(interviewId) {
      this.$api.recruitment
        .getNoticeOfInterviewMail(interviewId)
        .then((response) => {
          if (response.status === 200) {
            this.mailContent = response.data;
            $("#mailModal").modal("show");
          }
        });
    },

    // 檢視 錄取通知信件
    showHiringMail() {
      this.$api.notice.getNoticeOfHiringMail(this.MatchId).then((response) => {
        if (response.status === 200) {
          this.mailContent = response.data;
          $("#mailModal").modal("show");
        }
      });
    },

    // 檢視 報到通知信件
    showReportMail() {
      this.$api.notice.getNoticeOfReportMail(this.MatchId).then((response) => {
        if (response.status === 200) {
          this.mailContent = response.data;
          $("#mailModal").modal("show");
        }
      });
    },

    // 檢視 感謝函
    showThankYouMail() {
      this.$api.notice.getThankYouMail(this.MatchId).then((response) => {
        if (response.status === 200) {
          this.mailContent = response.data;
          $("#mailModal").modal("show");
        }
      });
    },

    // loading
    ...mapActions(["updateLoading"]),
  },

  watch: {
    // 點擊左側應聘紀錄
    selectedDemandMatchId: function (e) {
      if (e) {
        this.updateLoading(true);
        this.$api.recruitment.getJobHistoryByUserOfFront(e).then((response) => {
          if (response.status === 200) {
            this.jobHistoryList = response.data.JobHistoryList;
            this.ResumeType = response.data.ResumeType;
            this.MatchId = response.data.MatchId;
            this.showProgress = true;
          }
          this.updateLoading(false);
        });
      }
    },
  },

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  created() {
    this.getApplicationRecord();
  },
};
</script>

<style lang="scss" scoped>
.application-record {
  .progress-job-list {
    padding: 10px;
    padding-bottom: 22px;
    width: 30%;
    position: fixed;
    top: 100px;
    bottom: 23px;

    .job-item {
      background-color: rgba(255, 255, 255, 0.15);
      margin-bottom: 10px;
      padding: 10px 15px;
      color: #fff;
      display: flex;
      align-items: center;
      cursor: pointer;
      border-radius: 5px;
      border: 1px solid rgba(255, 255, 255, 0.35);
      .time {
        margin-right: 15px;
        text-align: center;
        span {
          display: block;
          font-family: Arial, Helvetica, sans-serif;
          font-weight: lighter;
          opacity: 0.6;
          &:nth-child(1) {
            font-size: 1.3em;
            margin-bottom: -9px;
          }
          &:nth-child(2) {
            font-size: 1.2em;
          }
        }
        .status {
          background-color: #abc7ec;
          color: #3b425d;
          font-size: 0.9em;
          font-weight: bolder;
          border-radius: 3px;
        }
      }
      .info {
        flex: 1;
        .job-name {
          font-size: 1.2em;
          margin-bottom: 10px;
        }
        .d-name,
        .d-nunber {
          font-size: 0.9em;
        }
      }
      .day {
        margin-left: 20px;
        i {
          display: block;
          opacity: 0.6;
        }
        .counter {
          font-size: 1.2em;
          display: inline-block;
        }
        span {
          font-size: 0.6em;
        }
      }

      &.active {
        background-color: #5380f7;
      }
    }
  }

  .timeline {
    padding-bottom: 22px;
    padding-left: 30px;
    text-align: center;
    margin-left: 30%;
    min-width: 1px;

    &::-webkit-scrollbar {
      width: 7px;
    }

    &::-webkit-scrollbar-button {
      background: transparent;

      border-radius: 4px;
    }

    &::-webkit-scrollbar-track-piece {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 4px;

      background-color: rgba(0, 0, 0, 0.4);

      border: 1px solid slategrey;
    }

    &::-webkit-scrollbar-track {
      box-shadow: transparent;
    }

    ul {
      border-left: 2px solid #fff;
      display: inline-block;
      list-style: none;
      padding-left: 40px;
      padding-top: 60px;
      width: 800px;
      li {
        padding-left: 40px;
        color: #fff;
        text-align: left;
        margin-bottom: 60px;
        position: relative;

        .icon-wrap {
          position: absolute;
          left: -64px;
          top: 20px;
          background-color: #3b425d;
          width: 50px;
          height: 50px;
          text-align: center;
          line-height: 50px;
          border-radius: 50%;
          border: 1px solid #fff;
          z-index: 3;
        }

        .time-wrap {
          font-weight: bolder;
          font-family: Arial, Helvetica, sans-serif;
          display: inline-block;
          border-bottom: 1px solid #fff;
          margin-left: -60px;
          padding-left: 60px;
          padding-right: 40px;
          position: relative;
          margin-bottom: 10px;
          font-size: 1.6em;
          opacity: 0.5;
          letter-spacing: 2px;
          width: 270px;

          &:after {
            content: "";
            width: 10px;
            height: 10px;
            border-radius: 50%;
            border: 1px solid #fff;
            display: inline-block;
            position: absolute;
            right: -5px;
            bottom: -5px;
            background-color: #fff;
          }
        }
        .text-wrap {
          font-size: 1.4em;
          font-weight: bold;
        }
        .note-wrap {
          opacity: 0.5;
        }

        .button-wrap {
          margin-top: 15px;
          .btn {
            background: #abc7ec;
            padding: 5px 15px;
            border-radius: 25px;
          }
        }

        &.welcome {
          div {
            font-size: 2em;
            font-weight: bolder;
          }
        }
      }
    }
  }

  /* EXTRA/CLIP PATH STYLES
–––––––––––––––––––––––––––––––––––––––––––––––––– */
  .timeline-clippy ul li::after {
    width: 40px;
    height: 40px;
    border-radius: 0;
  }

  .timeline-rhombus ul li::after {
    clip-path: polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%);
  }

  .timeline-rhombus ul li div::before {
    bottom: 12px;
  }

  .timeline-star ul li::after {
    clip-path: polygon(
      50% 0%,
      61% 35%,
      98% 35%,
      68% 57%,
      79% 91%,
      50% 70%,
      21% 91%,
      32% 57%,
      2% 35%,
      39% 35%
    );
  }

  .timeline-heptagon ul li::after {
    clip-path: polygon(
      50% 0%,
      90% 20%,
      100% 60%,
      75% 100%,
      25% 100%,
      0% 60%,
      10% 20%
    );
  }

  .timeline-infinite ul li::after {
    animation: scaleAnimation 2s infinite;
  }

  @keyframes scaleAnimation {
    0% {
      transform: translateX(-50%) scale(1);
    }
    50% {
      transform: translateX(-50%) scale(1.25);
    }
    100% {
      transform: translateX(-50%) scale(1);
    }
  }

  /* FOOTER STYLES
–––––––––––––––––––––––––––––––––––––––––––––––––– */
  .page-footer {
    position: fixed;
    right: 0;
    bottom: 20px;
    display: flex;
    align-items: center;
    padding: 5px;
    color: black;
    background: rgba(255, 255, 255, 0.65);
  }

  .page-footer a {
    display: flex;
    margin-left: 4px;
  }
}

.notice {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  letter-spacing: 2px;
  outline: 0;
  font: 24px Open Sans, sans-serif;
  color: #fff;
  cursor: default;
  text-align: center;
  img {
    width: 350px;
    opacity: 0.9;
  }
  p {
    margin: 0;
  }
}

#mailModal {
  .modal-content {
    background-image: url(~@/assets/img/card_bg.png);
    background-position: top;
    background-size: cover;
    &:after {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background-color: rgba(83, 128, 247, 0.85);
      background-color: rgba(59, 61, 64, 0.85);
      z-index: 1;
    }
    & > button {
      z-index: 2;
    }
    .modal-body {
      z-index: 2;

      .title {
        color: #fff;
        text-align: left;
        position: relative;
        font-family: Arial, Helvetica, sans-serif;
        font-weight: bolder;
        padding-left: 15px;

        &::after {
          content: "";
          position: absolute;
          background-color: #5380f7;
          width: 300px;
          height: 15px;
          left: 0;
          bottom: 7px;
        }

        h2,
        h4 {
          display: inline-block;
          position: relative;
          z-index: 2;
          text-shadow: 2px 2px 5px rgba(136, 107, 107, 0.2);
          letter-spacing: 1px;
        }

        h2 {
          margin-right: 10px;
        }
      }
      .form-content {
        background-color: #fff;
        padding: 20px;
        border-radius: 5px;
      }
    }
  }

  .form-content {
    input[type="text"],
    input[type="number"],
    select {
      width: 100%;
      border: none;
      background: #f5f5f5;
      margin: 15px 0 10px 0;
      padding: 6px 5px 6px 10px;
      letter-spacing: 1px;
      border-radius: 3px;
    }
    input[type="text"]::placeholder,
    input[type="number"]::placeholder {
      font-family: "微軟正黑體", sans-serif;
      letter-spacing: 1px;
    }
    input[type="text"]:focus,
    input[type="number"]:focus {
      outline: 0;
    }

    .submit-btn {
      margin-top: 30px;
      border-radius: 3px;
      color: #eee;
      letter-spacing: 2px;
      padding: 6px 30px;
      background-color: #5380f7;
    }

    /deep/ .date-select-style {
      .mx-input-wrapper {
        width: 100%;
        border: none;
        background: #f5f5f5;
        margin: 15px 0 10px 0;
        padding: 6px 5px 6px 10px;
        .mx-input {
          border: none;
          padding: 0;
          box-shadow: none;
          height: 24px;
          letter-spacing: 1px;
        }
        .mx-input::placeholder {
          font-family: "微軟正黑體", sans-serif;
          font-size: 16px;
          letter-spacing: 1px;
        }
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .application-record {
    padding: 0;
    .timeline {
      margin-left: 170px;
      padding-left: 0px;
      padding-top: 20px;
      ul {
        padding: 0 !important;
        width: 100%;
        border-left: none;

        li {
          padding-left: 30px;
          padding-right: 10px;
          margin-bottom: 10px;
          &:last-child {
            margin-bottom: 0;
          }

          .time-wrap {
            font-size: 1.1em;
            margin-left: 0;
            padding-left: 0;
            width: 100%;
            letter-spacing: 0px;
          }
          .icon-wrap {
            left: -10px;
            transform: scale(0.5);
            top: 1px;
          }
          .text-wrap {
            font-size: 0.9em;
          }
          .note-wrap {
            font-size: 0.8em;
          }
        }
      }
    }

    .progress-job-list {
      width: 165px;

      .job-item {
        display: block;
        padding: 5px;
        margin-bottom: 5px;
        .time {
          margin-right: 0;
          margin-bottom: 5px;

          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        .info {
          .job-name {
            font-size: 0.9em;
            margin-bottom: 5px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
          .d-number {
            font-size: 0.9em;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
        }
      }
    }
  }
}
</style>
